import { SettingState } from "./rootReducerTypes";

export type SettingsActionTypes = UpdateSettingAction;

export const UPDATE_SETTING = "UPDATE_SETTING";
export interface UpdateSettingAction {
  type: typeof UPDATE_SETTING;
  setting: { [key: string]: string };
}

//#region actions
export function updateSetting(setting: { [key: string]: string }): UpdateSettingAction {
  return {
    type: UPDATE_SETTING,
    setting: setting,
  };
}

export default function settingsReducer(state: SettingState = initialState, action: SettingsActionTypes): SettingState {
  switch (action.type) {
    case UPDATE_SETTING:
      const existingIndex = state.settings.findIndex(setting => setting.key === action.setting.key);

      const newSettings = [...state.settings];

      if (existingIndex !== -1) {
        newSettings[existingIndex] = action.setting;
      }
      else {
        newSettings.push(action.setting);
      }

      return {
        ...state,
        settings: newSettings
      };
    default:
      return state;
  }
}

export const initialState: SettingState = {
  settings: []
};